import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { CreateTenantColorBody, TenantColorDto, UpdateTenantColorBody } from '@nusign/picflow-backend-types';
import { map, of, switchMap, tap } from 'rxjs';
import { billingScopes } from '../billing-consts';
import { PICFLOW_CONFIG } from '../picflow-config';
import { ObservableDataLoaderService } from './observable-data-loader.service';
import { PermissionService } from './permission.service';

@Injectable({
  providedIn: 'root',
})
export class TenantColorsService {
  private http = inject(HttpClient);
  private config = inject(PICFLOW_CONFIG);
  private loader = inject(ObservableDataLoaderService);
  private permissionService = inject(PermissionService);

  public colors$ = of(null).pipe(
    switchMap(() => {
      if (!this.permissionService.canDisplayElement(billingScopes.tenantColors.create)) {
        return of([] as TenantColorDto[]);
      }

      return this.loader.get('tenant-colors', () => {
        // return of([] as TenantColorDto[]);
        return this.http
          .get<{ data: TenantColorDto[] }>(`${this.config.apiEndpoint}/tenant_colors`)
          .pipe(map(res => res.data));
      });
    })
  );

  public updateColor(colorId: string, params: UpdateTenantColorBody) {
    return this.http.patch<TenantColorDto>(`${this.config.apiEndpoint}/tenant_colors/${colorId}`, params).pipe(
      tap(color => {
        this.loader.update<TenantColorDto[]>('tenant-colors', colors => {
          if (!colors) return colors;
          const index = colors.findIndex(c => c.id === colorId);
          colors[index] = color;
          return colors;
        });
      })
    );
  }

  public addColor(params: CreateTenantColorBody) {
    return this.http.post<TenantColorDto>(`${this.config.apiEndpoint}/tenant_colors`, params).pipe(
      tap(color => {
        this.loader.update<TenantColorDto[]>('tenant-colors', colors => {
          if (!colors) return colors;
          colors.push(color);
          return colors;
        });
      })
    );
  }

  public deleteColor(colorId: string) {
    return this.http.delete(`${this.config.apiEndpoint}/tenant_colors/${colorId}`).pipe(
      tap(() => {
        this.loader.update<TenantColorDto[]>('tenant-colors', colors => {
          if (!colors) return colors;
          return colors.filter(c => c.id !== colorId);
        });
      })
    );
  }
}
